import { encryptPassword } from '../utils/Encryption';

import { getCookie } from '../utils/CookiesUtil';
import api from "./apiMethods";

const { REACT_APP_API_URL } = process.env;

export const getUsers = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-users-list`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getUsersBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-list-users`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zone_ids: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const getDeliveryMen = async ({ validatePermissions = 'true', filterActive = 'true' }) => {
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-dealers`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
      "validate_permissions": validatePermissions,
      "filter_active": filterActive,
    },
  };

  return api(request);

};

export const getDeliveryMenBySuperadmin = async () => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-dealers`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const getDeliveryMan = async (idDeliveryMan) => {

  const payload = {
    id_delivery_man: parseInt(idDeliveryMan)
  }

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/get-resume-delivery-man`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getUserCredits = async (idUser) => {

  const payload = {
    id_user: parseInt(idUser)
  }

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/business/get-credits-history`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getUserBalances = async (idUser) => {

  const payload = {
    id_user: parseInt(idUser)
  }

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/business/get-balance-history`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getClientInfo = async (idUser) => {

  const payload = {
    id_user: parseInt(idUser)
  }

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/get-info-users`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getPermissions = async () => {
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/permissions/get-permissions`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const updatePermissions = async (userId, permissions) => {
  const payload = {
    user_id: userId,
    permission_abbreviation_list: permissions
  }

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/permissions/manage-user-permissions`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const getDeliverers = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-info-dealers-counters`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getDeliverersBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-complete-info-dealers-counters`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const getCredits = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-business-list`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getBalances = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-balance-users`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const removeCredits = async (idUser, credits, commentary = '') => {

  const payload = {
    destiny_user: parseInt(idUser),
    credits_amount: parseInt(credits),
    commentary: commentary
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/reduce-credits`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const addCredits = async (idUser, credits, commentary) => {

  const payload = {
    destiny_user: parseInt(idUser),
    credits_amount: parseInt(credits),
    commentary: commentary
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/business/add-credits`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const addBalance = async (idUser, balance, commentary) => {

  const payload = {
    destiny_user: parseInt(idUser),
    type_case: "Aumento",
    amount: parseInt(balance),
    commentary: commentary,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/add-reduce-balance`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const reduceBalance = async (idUser, balance, commentary) => {

  const payload = {
    destiny_user: parseInt(idUser),
    type_case: "Reducción",
    amount: parseInt(balance),
    commentary: commentary,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/add-reduce-balance`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const changeUserStatus = async (idUser) => {

  const payload = {
    id_user_destiny: idUser,
    option_user_state: false,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/change-user-state`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};


export const createUser = async (user) => {

  const prePayload = {
    user_name: user.name,
    paternal_lastname: user.middleName,
    maternal_lastname: user.lastName,
    telephone_number: user.phoneNumber,
    email: user.email,
    password: encryptPassword(user.password),
  };

  const payload = {
    role_type: user.role,
    user_info: prePayload,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/add-delivery-man-admin`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const createSuperAdminUser = async (user) => {

  const prePayload = {
    user_name: user.name,
    paternal_lastname: user.middleName,
    maternal_lastname: user.lastName,
    telephone_number: user.phoneNumber,
    email: user.email,
    password: encryptPassword(user.password),
    is_zone_manager: user.is_zone_manager,
    available_zones: user.available_zones,
  };

  const payload = {
    role_type: user.role,
    user_info: prePayload,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/add_delivery_man_admin_by_superadmin`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const updateUser = async (idUser, email, phoneNumber, name, paternalLastname, maternalLastname) => {

  const payload = {
    id_user: idUser,
    user_email: email,
    telephone_number: phoneNumber,
    user_name: name,
    paternal_lastname: paternalLastname,
    maternal_lastname: maternalLastname,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/update-user-info`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const updateClientCategory = async (idUser, idCategory) => {

  const payload = {
    id_user_destiny: idUser,
    new_id_membership_type: idCategory,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/memberships/update-user-membership-type-by-admin`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const updateUserPassword = async (idUser, newPassword) => {

  const payload = {
    id_user: idUser,
    password: newPassword,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/change-password`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const cashClosing = async (idDeliveryMan, failedGuides, pendingGuides, deliveredGuides, amount) => {

  const payload = {
    id_delivery_man: idDeliveryMan,
    failed_delivered_guides: pendingGuides,
    pending_guides: failedGuides,
    delivered_guides: deliveredGuides,
    balance_amount: parseInt(amount, 10),
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/create-guides-cut`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const createWarehouseByAdmin = async (warehouseData) => {
  const userInfo = {
    user_name: warehouseData.name,
    paternal_lastname: warehouseData.middleName,
    maternal_lastname: warehouseData.lastName,
    telephone_number: warehouseData.phoneNumber,
    email: warehouseData.email,
    password: encryptPassword(warehouseData.password),
  };

  const warehouseLocation = {
    postal_code: warehouseData.zipCode,
    alias: warehouseData.addressAlias,
    state: warehouseData.state,
    city: warehouseData.city,
    colony: warehouseData.suburb,
    street_name: warehouseData.street,
    ext_number: warehouseData.outdoorNumber,
    int_number: warehouseData.interiorNumber || "",
    references: warehouseData.addressReferences || "",
  };

  const payload = {
    user_info: userInfo,
    warehouse_location: warehouseLocation,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/add-warehouse`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const createWarehouseBySuperadmin = async (warehouseData) => {
  const userInfo = {
    user_name: warehouseData.name,
    paternal_lastname: warehouseData.middleName,
    maternal_lastname: warehouseData.lastName,
    telephone_number: warehouseData.phoneNumber,
    email: warehouseData.email,
    password: encryptPassword(warehouseData.password),
    available_zones: warehouseData.available_zones,
  };

  const warehouseLocation = {
    postal_code: warehouseData.zipCode,
    alias: warehouseData.addressAlias,
    state: warehouseData.state,
    city: warehouseData.city,
    colony: warehouseData.suburb,
    street_name: warehouseData.street,
    ext_number: warehouseData.outdoorNumber,
    int_number: warehouseData.interiorNumber || "",
    references: warehouseData.addressReferences || "",
  };

  const payload = {
    user_info: userInfo,
    warehouse_location: warehouseLocation,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/add-warehouse`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};

export const updateClientAccountStatus = async (idUser, accountStatus) => {

  const payload = {
    id_user_destiny: idUser,
    new_account_status: accountStatus,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/update-status-account`, // DUMMY URL
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};